const passwordValidation = [
  {
    hasError: (password) => password.length < 8,
    errorText: 'длина меньше 8 символов',
  },
  {
    hasError: (password) => /\s/.test(password),
    errorText: 'присутствуют пробелы',
  },
  {
    hasError: (password) => /[а-яйё]/i.test(password),
    errorText: 'используется кириллица',
  },
  {
    hasError: (password) => !/[^a-zа-яйё0-9]/i.test(password),
    errorText: 'нет специальных символов',
  },
  {
    hasError: (password) => !/[a-z]/i.test(password),
    errorText: 'нет букв',
  },
  {
    hasError: (password) => password.toLowerCase() === password,
    errorText: 'нет заглавных букв',
  },
  {
    hasError: (password) => password.toUpperCase() === password,
    errorText: 'нет строчных букв',
  },
  {
    hasError: (password) => !/\d/.test(password),
    errorText: 'нет цифр',
  },
];

export default passwordValidation;
